import { ReactNode, useMemo, useState } from 'react';
import OrganizationDataContext from '@raas/shared/src/features/organization/contexts/OrganizationContext';
import type { OrganizationContract } from '@raas/shared/src/features/organization/contracts/organization.type';

type OrganizationProviderProps = {
  children: ReactNode;
};

export function OrganizationProvider({ children }: OrganizationProviderProps) {
  const [organizations, setOrganizations] = useState<OrganizationContract[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dataValue = useMemo(
    () => ({
      organizations,
      isLoading,
      setOrganizations,
      setIsLoading,
    }),
    [organizations, isLoading]
  );
  return (
    <OrganizationDataContext.Provider value={dataValue}>
      {children}
    </OrganizationDataContext.Provider>
  );
}
